import React, { useState } from 'react'

import classNames from 'classnames'
import Fab from '@mui/material/Fab'
import { makeStyles } from '@mui/styles'

import SvgIcon from 'modules/base/components/svg-icon/svg-icon'

const SpeedDial = props => {
  const classes = useStyles(props)
  const [isOpen, setIsOpen] = useState(false)

  const { children, icon } = props

  const handleClick = () => {
    setIsOpen(!isOpen)
  }

  const actions = React.Children.toArray(children).map((action, index) => {
    return React.cloneElement(action, {
      isOpen,
    })
  })

  return (
    <div className={classes.root}>
      <Fab
        onClick={handleClick}
        className={classes.fab} >
        <SvgIcon
          svg={icon}
          fill='#fff'
          height="16px"
          width="16px" />
      </Fab>
      <div className={
        classNames(
          classes.actions,
          {
            [classes.actionsClosed]: !isOpen,
          },
        )
      }>{actions}</div>
    </div>
  )
}

const dialRadius = 28
const spacingActions = 12

const useStyles = makeStyles(theme => ({
  root: {
    zIndex: 9,
    display: 'flex',
    alignItems: 'center',
    pointerEvents: 'none',
    flexDirection: 'column-reverse',
    '& $actions': {
      flexDirection: 'column-reverse',
      marginBottom: -dialRadius,
      paddingBottom: spacingActions + dialRadius,
    },
  },
  fab: {
    pointerEvents: 'auto',
    background: `linear-gradient(180deg, ${theme.primaryLight}, ${theme.primaryDark})`,
    boxShadow: '0px 5px 5px 0 rgba(0, 0, 0, 0.5)',
    cursor: 'pointer',
    width: '48px',
    height: '48px',
  },
  actions: {
    display: 'flex',
    pointerEvents: 'auto',
  },
  actionsClosed: {
    transition: 'top 0s linear 0.2s',
    pointerEvents: 'none',
  },
}))

export default SpeedDial
